import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import ModuleSelect from './ModuleSelect'
import Unauthroized from './UnAuthorized'
import { utils } from 'unity-core'
const { userUtils } = utils

const propTypes = {
  user: PropTypes.object.isRequired
}
const defaultProps = {}

export function Home(props) {
  return !userUtils.IsAuthorized(props.user) ? <Unauthroized /> : (
    <div>
      <ModuleSelect {...props} />
    </div>
  )
}

Home.propTypes = propTypes
Home.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(Home)
